import {TimeUtils, DurationConverter} from '@colonist/utils'

interface SeasonTiming {
    monthsLeft: number
    weeksLeft: number
    daysLeft: number
    hoursLeft: number
    minutesLeft: number
}

export const getSeasonTiming = (seasonTimeRemaining: number): SeasonTiming => ({
    monthsLeft: Math.floor(seasonTimeRemaining / DurationConverter.monthsAsMilliseconds(1)),
    weeksLeft: Math.floor(seasonTimeRemaining / DurationConverter.weeksAsMilliseconds(1) % TimeUtils.WEEKS_IN_MONTH),
    daysLeft: Math.floor((seasonTimeRemaining / DurationConverter.daysAsMilliseconds(1) % TimeUtils.DAYS_IN_MONTH) % TimeUtils.DAYS_IN_WEEK),
    hoursLeft: Math.floor(seasonTimeRemaining / DurationConverter.hoursAsMilliseconds(1) % TimeUtils.HOURS_IN_DAY),
    minutesLeft: Math.floor(seasonTimeRemaining / DurationConverter.minutesAsMilliseconds(1) % TimeUtils.MINUTES_IN_HOUR),
})

export const getSeasonTimingText = (seasonTiming: SeasonTiming) => {
    const lessThanTwoDaysLeftUntilSeasonEnd = seasonTiming.monthsLeft == 0 && seasonTiming.weeksLeft == 0 && seasonTiming.daysLeft < 2
    const totalDaysLeft = seasonTiming.daysLeft + (seasonTiming.weeksLeft * 7)
    const daysInHours = totalDaysLeft * TimeUtils.HOURS_IN_DAY
    const totalHoursLeft = daysInHours + seasonTiming.hoursLeft

    if(lessThanTwoDaysLeftUntilSeasonEnd) return `${totalHoursLeft}H ${seasonTiming.minutesLeft}M`
    if(seasonTiming.monthsLeft > 0) return `${seasonTiming.monthsLeft}M ${totalDaysLeft}D`
    return `${totalDaysLeft}D`
}
